import { Badge } from '@parcel/ui';
import { type ApiRoleFamily, personaLabel } from '../../lib/enrich.js';

export function PersonaTag({ family, match }: { family: ApiRoleFamily | null; match: boolean }) {
  if (!family) return null;
  return (
    <Badge
      variant={match ? 'brand' : 'outline'}
      className="shrink-0 whitespace-nowrap px-1.5 py-0 text-[11px]"
      data-persona-match={String(match)}
    >
      {personaLabel(family)}
    </Badge>
  );
}
